import React from 'react';
import './i18n';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Dashboard from './components/Dashboard';
import Features from './components/Features';
import ForWho from './components/ForWho';
import Compatibility from './components/Compatibility';
import AITechnology from './components/AITechnology';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <HowItWorks />
      <Dashboard />
      <Features />
      <ForWho />
      <Compatibility />
      <AITechnology />
      <CTA />
      <Footer />
    </div>
  );
}

export default App; 